import classNames from 'classnames';
import { FunctionComponent } from 'react';

import IProject from 'types/Project';
import ProjectLeaf from './ProjectLeaf/ProjectLeaf';
import './ProjectTree.scss';

export interface IProjectTreeProps {
  project: IProject | null;
  onChange: (project: IProject) => void;
  onProjectToggled?: (project: IProject) => void;
  value: IProject | null;
  showArchived?: boolean;
  className?: string | object;
  openByDefault?: boolean;
}

export const ProjectTree: FunctionComponent<IProjectTreeProps> = (props) => {
  const { className, onChange, onProjectToggled, project, value, showArchived, openByDefault } = props;

  const classes = classNames('project-tree', className);

  return (
    <div className={classes}>
      <ProjectLeaf
        className="top-leaf"
        onChange={onChange}
        onProjectToggled={onProjectToggled}
        showArchived={showArchived}
        project={project!}
        openByDefault={openByDefault ?? true}
        value={value}
        isTopLevel={true}
      />
    </div>
  );
};

export default ProjectTree;
